import { useEffect } from 'react';
import { useCurrentEquipmentService, useEquipmentCatalog, useEquipmentInventory } from '@zep/apis';
import { useAuth } from '@zep/auth';
import { buildAssetsUrl, resolveEquipmentCatalogAssetPaths } from '@zep/utils';
function isAbsoluteAssetPath(path: string): boolean {
  return /^https?:\/\//i.test(path) || path.startsWith('//') || path.startsWith('data:');
}
function resolveEquipmentAssetPath(path: string): string {
  if (isAbsoluteAssetPath(path)) {
    return path;
  }
  return buildAssetsUrl(path);
}
export function EquipmentCatalogBootstrapper() {
  const service = useCurrentEquipmentService();
  const {
    isAuthenticated,
    isInitialized,
    user
  } = useAuth();
  const {
    data: inventory
  } = useEquipmentInventory({
    userHashId: user?.hashId,
    enabled: isInitialized && isAuthenticated
  });
  const {
    data
  } = useEquipmentCatalog(service, {
    inventory
  });
  useEffect(() => {
    if (!data) return;
    let cancelled = false;
    // Defer `@zep/game` to runtime: its barrel pulls Phaser at module-eval,
    // which touches `HTMLVideoElement` and crashes under Next SSR.
    import('@zep/game').then(({
      registerEquipmentCatalog
    }) => {
      if (cancelled) return;
      registerEquipmentCatalog(resolveEquipmentCatalogAssetPaths(data, resolveEquipmentAssetPath));
    });
    return () => {
      cancelled = true;
    };
  }, [data]);
  return null;
}